'use strict';

var Sugar = require('sugar-core'),
    _numberOptions = require('./var/_numberOptions');

module.exports = Sugar.Number.getOption;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/getOption.js
// module id = 673
// module chunks = 0